import React, {useState, useRef, useEffect} from 'react';
import Card from "../../components/Card";
import {PRODUCT_PAGES} from "../JobProductPage";
import CreateEditCustomer from "../../components/customer/CreateEditCustomer";
import CreateEditProduct from "../../components/job/product/CreateEditProduct";
import {toast} from "react-toastify";

const JobProductCreateEditPage = (props) => {
    const {
        jobId           = null,
        productId       = null,
        parentId        = "",
        onChangePage    = (INDEX, product) => {}
    } = props;

    const [product, setProduct] = useState(null);

    const reset = () => {
        setProduct(null);
    }

    const handleClickBack = (event) => {
        event.preventDefault();
        reset();
        onChangePage(PRODUCT_PAGES.INDEX, null);
    }

    const handleCancel = () => {
        reset();
        onChangePage(PRODUCT_PAGES.INDEX, null);
    }

    const handleComplete = (product) => {
        if (!!productId) {
            toast.success(<div>{"Product updated."}</div>);
        } else {
            toast.success(<div>{"Product created."}</div>);
        }

        reset();
        onChangePage(PRODUCT_PAGES.INDEX, null);
    }

    const handleDelete = () => {
        toast.success(<div>{"Product deleted."}</div>);

        reset();
        onChangePage(PRODUCT_PAGES.INDEX, null);
    }

    return (
        <React.Fragment>
            <Card
                title={!!productId ? "Edit Product" : "Create Product"}
                classes={"mh-100 border-0"}
                controls={can('viewAny', 'product') ? (
                    <button
                        onClick={(event) => handleClickBack(event)}
                        className={"btn font-weight-bold btn-outline-eh-off-black px-4 m-0"}
                    >
                        <i className={"fa fa-chevron-left mr-2"} />
                        <span>{"Back"}</span>
                    </button>
                ) : null}
            >
                <CreateEditProduct
                    jobId={jobId}
                    productId={productId}
                    onCancel={() => handleCancel()}
                    onComplete={(product) => handleComplete(product)}
                    onDelete={() => handleDelete()}
                    parentId={parentId}
                />
            </Card>
        </React.Fragment>
    );
}

export default JobProductCreateEditPage;
